import { Inter } from 'next/font/google'

/** The app's standard UI font. */
export const inter = Inter({ subsets: ['latin'] })

// Expose the generated family at the root so body-level portals share it.
export const appFontCss = `:root { --app-ui-font: ${inter.style.fontFamily}; }`
